import { Tacitly } from "./Tacitly";
import CryptoJS from "crypto-js";
import DES from "crypto-js/tripledes";
import modeEcb from "crypto-js/mode-ecb";
import routes from "../../router/routes.js";
import Router from "vue-router";
import { message } from "ant-design-vue";
let router = new Router({
  routes,
});

class Commit {
  encode(data) {
    //加密
    // var keyHex = CryptoJS.enc.Utf8.parse(Tacitly.key);
    // var encrypted = CryptoJS.DES.encrypt(data, keyHex, {
    //   mode: CryptoJS.mode.ECB,
    //   padding: CryptoJS.pad.Pkcs7
    // });
    // return encrypted.toString();
    return data;
  }
  decode(data) {
    //解密
    // let keyHex = CryptoJS.enc.Utf8.parse(Tacitly.key);
    // let decrypted = CryptoJS.DES.decrypt({
    //   ciphertext: CryptoJS.enc.Base64.parse(data)
    // }, keyHex, {
    //   mode: CryptoJS.mode.ECB,
    //   padding: CryptoJS.pad.Pkcs7
    // });
    // return decrypted.toString(CryptoJS.enc.Utf8);
    return data;
  }
}

class Cookie {
  constructor(name, value, days) {
    this.name = name; //存储名
    this.value = value; //存储内容
    this.days = days; //时间
  }
  set(name = this.name, value = this.value, days) {
    var d = new Date();
    if (days == null) {
      days = 1;
    }
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  get(name = this.name) {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : null;
  }
  delete(name = this.name) {
    this.set(name, "", -1);
  }
  clear() {
    let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (let i = keys.length; i--; )
        document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
    }
  }
}
class History {
  set() {
    new Cookie().set("back", new Commit().encode(window.location.href));
  }
  get() {
    window.location.href = new Commit().decode(new Cookie().get("back"));
    setTimeout((e) => {
      window.history.go(0);
      new Cookie().delete("back");
    }, 200);
  }
}

const urlEncode = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

// const AUTH = (key) => {
//   let user = localStorage.getItem("t") ? JSON.parse(new Commit().decode(localStorage.getItem("user"))) : null;
//   if (user) {
//     let allNode = user.link_group.filter((ele) => {
//       return ele.user_group_id === 1
//     }).length > 0  //是否有超级管理员权限
//     if (allNode) {
//       return true
//     } else {
//       let ruleNode = []
//       user.link_group.forEach(ele => {
//         ruleNode = ruleNode.concat(ele.group.view)
//       });
//       ruleNode = ruleNode.filter((ele, index) => {
//         return ruleNode.indexOf(ele) === index;
//       })
//       return ruleNode.filter((ele) => {
//         return ele === key
//       }).length > 0
//     }
//   } else {
//     return false
//   }
// }
const AUTH = (key) => {
  let user = localStorage.getItem("t")
    ? JSON.parse(new Commit().decode(localStorage.getItem("user")))
    : null;
  if (!user) {
    router.push("/login"); //重定向路由到登录页
    window.location.reload(); //刷新页面
    return;
  }
  if (user.id <= 1) {
    return true;
  } else {
    if (key == "test") return true;
    else {
      let Nkey = key.split(",");
      return (
        Nkey.filter((ele) => {
          return (
            user.baseMenu.indexOf(ele) >= 0 ||
            user.accuserIds
              .map((s) => {
                return user.accuserMenu.indexOf(s + "#" + ele) >= 0;
              })
              .filter((k) => {
                return k === true;
              }).length > 0
          );
        }).length > 0
      );
    }
  }
};

const AccAUTH = (accId, key) => {
  //原告权限
  let user = localStorage.getItem("t")
    ? JSON.parse(new Commit().decode(localStorage.getItem("user")))
    : null;
  if (!user) {
    router.push("/login"); //重定向路由到登录页
    window.location.reload(); //刷新页面
    return;
  }
  if (user.id <= 1) {
    return true;
  } else if (key === "true") return true;
  else {
    return user.accuserMenu.indexOf(accId + "#" + key) >= 0;
  }
};

function filterOption(input, option) {
  return (
    option.componentOptions.children[0].text
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0
  );
}
export default {
  Cook: new Cookie(),
  DES: new Commit(),
  urlEncode: urlEncode,
  back: new History(),
  AUTH: AUTH,
  AccAUTH: AccAUTH,
  filterOption: filterOption,
};
